// ⛔ WHY THIS EXISTS. Corners and cards lines live only in the operator's bet-builder
// board, and the SDK kept them only as a side effect of `fetchBetBuilderStakes` — whose
// one caller is the ADD tap. Pricing never fetches that board (it goes through the
// app's own service, or through a reply for a SELECTED pair whose prices are combo
// prices). MEASURED 2026-10-02: 28 add taps in 14 days, 0 corners/cards singles shown,
// 0 `@4:`/`@5:` verdict rows. The board has to be asked for, once, on purpose.

export const SUB_WARM_INTERVAL_MS = 10 * 60_000;

export function shouldWarmSubLines(a: {
  openId: string | null;
  isLive: boolean;
  loggedIn: boolean;
  have: number;
  lastTriedAt: number | undefined;
  now: number;
}): boolean {
  return Boolean(a.openId)
    && !a.isLive
    && a.loggedIn
    && a.have === 0
    && (a.lastTriedAt === undefined || a.now - a.lastTriedAt >= SUB_WARM_INTERVAL_MS);
}
